<script setup lang="ts">
  import { computed } from 'vue'
  import CachedImage from '../CachedImage.vue'
  import { useEmployeeStore } from '@/stores/EmployeeStore'
  import { storeToRefs } from 'pinia'

  interface Props {
    employeeId?: number
    size?: number
    textSize?: string
  }

  const props = defineProps<Props>()
  const employeeStore = storeToRefs(useEmployeeStore())

  const employee = computed(() => {
    if (props.employeeId) {
      return employeeStore.getEmployeeById.value(props.employeeId)
    }
    const selectedEmployee = employeeStore.employee.value
    if (selectedEmployee) {
      return selectedEmployee
    }
    return employeeStore.teamleader.value
  })

  const initials = computed(() => {
    if (employee.value) {
      return employee.value.initials()
    }
    return ''
  })

  const heightAndWidth = computed(() => {
    if (props.size) {
      return `h-${props.size} w-${props.size}`
    }
    return 'h-12 w-12'
  })

  const textSize = computed(() => {
    if (props.textSize) {
      return `text-${props.textSize}`
    }
    return 'text-xl'
  })

  const initalsExtraClasses = computed(() => {
    return `${heightAndWidth.value} ${textSize.value}`
  })
</script>
<template>
  <cached-image
    v-if="employee?.avatar_url"
    :src="employee.avatar_url"
    class="rounded-full object-cover"
    :class="heightAndWidth"
  />
  <div
    v-else-if="employee"
    :class="initalsExtraClasses"
    class="bg-gray-100 rounded-full text-gray-300 font-bold flex items-center justify-center"
  >
    {{ initials }}
  </div>
  <div
    v-else
    class="bg-gray-200 rounded-full flex justify-center items-center"
    :class="heightAndWidth"
  >
    <font-awesome-icon icon="fa-solid fa-user " class="text-white text-3xl" />
  </div>
</template>
